// Tickets API Adapter
// Routes to live API or mockData based on feature flag

import { isLive } from './config';
import apiClient from './client';
import { mockTickets } from '../mockData';

// Get user's tickets
export async function getMyTickets() {
  if (!isLive('tickets')) {
    return { success: true, data: mockTickets };
  }

  try {
    return await apiClient.get('/tickets/mine');
  } catch (error) {
    console.error('[Tickets API] Failed to fetch tickets, falling back to mock:', error);
    return { success: true, data: mockTickets, _fallback: true };
  }
}

// Get ticket by ID
export async function getTicket(ticketId) {
  if (!isLive('tickets')) {
    const ticket = mockTickets.find(t => t.id === ticketId);
    return { success: true, data: ticket || null };
  }

  try {
    return await apiClient.get(`/tickets/${ticketId}`);
  } catch (error) {
    console.error('[Tickets API] Failed to fetch ticket, falling back to mock:', error);
    const ticket = mockTickets.find(t => t.id === ticketId);
    return { success: true, data: ticket || null, _fallback: true };
  }
}

// Purchase ticket (creates Stripe checkout session)
export async function purchaseTicket(ticketTypeId, quantity = 1) {
  if (!isLive('payments')) {
    // Mock purchase
    const newTicket = {
      id: `ticket-${Date.now()}`,
      ticketTypeId,
      quantity,
      status: 'confirmed',
      purchasedAt: new Date().toISOString(),
    };
    return { success: true, data: newTicket };
  }

  return await apiClient.post('/tickets/purchase', { ticketTypeId, quantity });
}

export default {
  getMyTickets,
  getTicket,
  purchaseTicket,
};
